import { render, staticRenderFns } from "./ProductDetailsView.vue?vue&type=template&id=70550e30&scoped=true"
import script from "./ProductDetailsView.vue?vue&type=script&lang=js"
export * from "./ProductDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70550e30",
  null
  
)

export default component.exports